import moment from 'moment-timezone'

export function registerLocalStorage (tokenInfo) {
  localStorage.setItem('user_token', tokenInfo['access_token'])
  localStorage.setItem('refresh_token', tokenInfo['refresh_token'])
  localStorage.setItem('token_exp', tokenInfo['expires'])

  // set token expiry timer (interval set to update 2 mins before expiry): default 10mins (600000ms)
  tokenInfo['expires'] = tokenInfo['expires']
    ? moment(tokenInfo.expires * 1000) - Date.now() - 120000
    : 600000
  localStorage.setItem('token_exp_timer', tokenInfo['expires'])
}

export function clearLocalStorage () {
  localStorage.removeItem('user_token')
  localStorage.removeItem('refresh_token')
  localStorage.removeItem('user_profile')
}



// WEBPACK FOOTER //
// ./src/utilities/localstorage.helper.js